import Chip from '@mui/material/Chip'

const CheckRiskStatus = ({ checkLength, hasChecks, label = 'registro' }) => {
  if (hasChecks) {
    return (
      <Chip
        label={`${checkLength} ${label}${checkLength > 1 ? 's' : ''}`}
        sx={{ backgroundColor: '#ff8a00', color: '#f7e89b' }}
        size="small"
      />
    )
  }

  return <Chip label="Sem registros" sx={{ backgroundColor: '#00b85f', color: '#cdf9e7' }} size="small" />
}

export default CheckRiskStatus
